export enum Permission {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN_ITEMS = 'ADMIN_ITEMS',
  ADMIN_TESTS = 'ADMIN_TESTS',
  ADMIN_MATRICES = 'ADMIN_MATRICES',
  ADMIN_EVENTS = 'ADMIN_EVENTS',
  ADMIN_USERS = 'ADMIN_USERS',
  ADMIN_REPOSITORIES = 'ADMIN_REPOSITORIES',
  DEVOLUTIVE = 'DEVOLUTIVE',
  DEVOLUTIVE_BRANDS = 'DEVOLUTIVE_BRANDS',
  DEVOLUTIVE_SCHOOLS = 'DEVOLUTIVE_SCHOOLS',
  DEVOLUTIVE_STUDENTS = 'DEVOLUTIVE_STUDENTS',
  DEVOLUTIVE_SINGLE_STUDENTS = 'DEVOLUTIVE_SINGLE_STUDENTS',
  ONLINE_TESTS = 'ONLINE_TESTS',
  CUSTOMIZE_EVENTS_CONFIGURATION = 'CUSTOMIZE_EVENTS_CONFIGURATION',
  ADMIN_SCHOOLS = 'ADMIN_SCHOOLS',
  ADMIN_STUDENTS = 'ADMIN_STUDENTS',
  ADMIN_CLASSES = 'ADMIN_CLASSES',
  ADMIN_TAGS = 'ADMIN_TAGS',
  ADMIN_EXAMS = 'ADMIN_EXAMS',
}

export type PermissionType = keyof typeof Permission;
